import styled from '@emotion/styled';
import {
  spacing,
  mediaMax,
  fontSize,
  fontWeight,
} from 'presentations/views/styles';
import BlogItem from 'presentations/views/components/molecules/BlogListItem';
import Pagination, {
  Props as PaginationProps,
} from 'presentations/views/components/atoms/Pagination';
import { BlogListItem } from 'presentations/api/schema/contents';

export interface Props {
  title?: string;
  items: BlogListItem[];
  paginationProps: PaginationProps;
}

export default function Component(props: Props) {
  return (
    <Container>
      <ListContainer>
        {(props.items || []).map((item) => (
          <ItemContainer key={item.id}>
            <BlogItem item={item} />
          </ItemContainer>
        ))}
      </ListContainer>
      <PaginationContainer>
        <Pagination {...props.paginationProps} />
      </PaginationContainer>
    </Container>
  );
}

const Container = styled.div``;
const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${spacing(24)};
  ${mediaMax.tablet} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const ItemContainer = styled.div``;

const PaginationContainer = styled.div`
  padding: ${spacing(56)} 0 0 0;
  display: flex;
  justify-content: center;

  ${mediaMax.tablet} {
    padding: ${spacing(20)} 0 0 0;
  }
`;
